// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 308) return "javascript/build/vendor.js";
	// return url for filenames based on template
	return "javascript/build/chunks/" + chunkId + ".js?hash=" + "b0121b65a146b56d" + "";
};